const tenant_management_zh = {
  edit_tenant_info:'编辑租户信息',
  empty_name:'请输入租户名称',
  empty_code:'请输入租户编码'
}

export default tenant_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/tenant_management/tenant_management_zh.js